<template>
    <div class="content-box">
        <div class="content-box-title" :class="getTitlePos">
            <slot name="title">{{title}}</slot>
        </div>
        <div class="content-box-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'contentBox',
    props: {
        titleLeft: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: '头部信息'
        }
    },
    computed: {
        getTitlePos: function() {
            return this.titleLeft?'txt-left': '';
        }
    },
    mounted(){
        //console.log(this.titleLeft);
    }
}
</script>

<style scoped>
.content-box {
    position: relative;
    height: 100%;
    border: 1px solid #FFFFFF;
    border-radius: 0.08rem;
    font-size: 0.16rem;
}
.content-box-title {
    position: absolute;
    top: 0.04rem;
    left: 0.04rem;
    right: 0.04rem;
    padding-left: 0.1rem;
    border-radius: 0.06rem;
    font-size: 0.14rem;
    text-align: center;
    background-image: linear-gradient(rgb(62, 189, 201), #016A95,#00638D, #006999, #009EE3);
    line-height: 0.32rem;
    font-weight: bold;
}
.content-box-title.txt-left {
    text-align: left;
}
.content-box-content {
    position: absolute;
    top: 0.4rem;
    left: 0.04rem;
    right: 0.04rem;
    bottom: 0;
    overflow-y: auto;
}
</style>


